module.exports = __webpack_public_path__ + "static/media/truck.c5d0db10.svg";